import makeCrud from '../crud';
import httpReq from '../request';

const WAYPOINT = 'waypoint';
const crud = new makeCrud(WAYPOINT);

var config = {
    "headers": {
        "Authorization": "Basic " + localStorage.getItem('token')
    }
};

const index = {
    save: (data) => {
        return crud.save(data)
    },
    update: (data) => {
        return crud.update(data)
    },
    delete: (id) => {
        return crud.delete(id)
    },
    findById: (id) => {
        return crud.findById(id)
    },
    findAllByUserId: async () => {
        var user = JSON.parse(localStorage.getItem("user"));
        return (await httpReq.get('/api/waypoint/search/findAllByUserId?userId=' + user.id, config)).data._embedded.waypoint;
    },
}

export default index;